'use client';

import { useEffect } from 'react';
import { useChatPageContext } from '@/contexts/ChatPageContext';

export function useChatPage(page: string) {
  const { setPageContext } = useChatPageContext();

  useEffect(() => {
    setPageContext({ page });
  }, [page, setPageContext]);
}
